import React, { useState, useEffect, useContext } from 'react'
import styled from 'styled-components'
import { useStateValue } from '../providers/StateProvider'
import { ThemeContext } from '../providers/ThemeProvider'
import Card from '../components/Card'

const Main = styled.div`
  min-height: 100vh;
  max-width: 1400px;
  margin: 0 auto;

	form {
  	color: #888;
  	margin: 32px 16px 0 16px;
	}

	h1 {
		font-size: 2em;
		margin-bottom: 32px;
	}

	textarea {
		background-color: transparent;
		color: #888;
		font-family: 'PT Mono';
		font-size: 1.5em;
		width: 100%;
		border: none;
		resize: none;
		height: auto;
	}
`

const Error = styled.p`
	background-color: #000;
	color: #888;
	font-size: 1.25em;
	padding: 16px;
	border-radius: 4px;
	margin-left: 16px;
`

const Cards = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
`

const Team = (props) => {
  const [dustedIds, setDustedIds] = useState([])
	const { mode } = useContext(ThemeContext)
	const { team, teamName, removeFromTeam, newTeamName } = useStateValue()

  useEffect(() => {
    if (mode === 'hydra') {
      const timeoutId = setTimeout(() => {
        removeFromTeam(dustedIds)
        setDustedIds([])
      }, 4000)
      return () => clearTimeout(timeoutId)
    } else {
      removeFromTeam(dustedIds)
    }
  }, [dustedIds])

  //If in Villain mode, this click triggers the dust animation.
	const handleClick = id => {
		setDustedIds([...dustedIds, id])
	}

	return (
		<Main>
			<form>
				<h1>Assemble the Team</h1>
				<textarea
					placeholder='Enter Team Name'
					value={ teamName }
					onChange={ e => newTeamName(e.target.value) }
				/>
			</form>
			<Cards>
				{(team.length === 0) ?
					<Error>No team yet.</Error>
					: team.map( (character, index) =>
							<Card
								toDust={ true }
								dusted = { Boolean(dustedIds.find(id => id === character.id)) }
								remove={ true }
								onClick={ e => handleClick(character.id) }
								key={ index }
								id={ character.id }
								img={ character.image }
								alt={ character.name }
								name={ character.name }
							/>
						)
				}
			</Cards>
		</Main>
	)
}

export default Team
